import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enHome from './locales/en/home.json';
import hiHome from './locales/hi/home.json';
import enLogin from './locales/en/login.json';
import hiLogin from './locales/hi/login.json';
import enProfile from './locales/en/profile.json';
import hiProfile from './locales/hi/profile.json';
import enDashboard from './locales/en/dashboard.json';
import hiDashboard from './locales/hi/dashboard.json';
import enQuestion from './locales/en/question.json';
import hiQuestion from './locales/hi/question.json';
import enAbout from './locales/en/about.json';
import hiAbout from './locales/hi/about.json';
import enReports from './locales/en/reports.json';
import hiReports from './locales/hi/reports.json';
import enSidebar from './locales/en/evaluatorSidebar.json';
import hiSidebar from './locales/hi/evaluatorSidebar.json';
import enEvaluator from './locales/en/evaluator.json';
import hiEvaluator from './locales/hi/evaluator.json';

i18n.use(initReactI18next).init({
  resources: {
    en: { 
      home: enHome,
      login: enLogin,
      profile: enProfile,
      dashboard: enDashboard,
      question: enQuestion,
      about: enAbout,
      reports: enReports,
      evaluatorSidebar: enSidebar,
      evaluator: enEvaluator
    },
    hi: { 
      home: hiHome,
      login: hiLogin,
      profile: hiProfile,
      dashboard: hiDashboard,
      question: hiQuestion,
      about: hiAbout,
      reports: hiReports,
      evaluatorSidebar: hiSidebar,
      evaluator: hiEvaluator
    },
  },
  lng: 'en', // default language
  fallbackLng: 'en',
  ns: ['home', 'login', 'profile', 'dashboard', 'question', 'about', 'reports', 'sidebar', 'evaluator'],
  defaultNS: 'home',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
